import { graphql } from 'gatsby';
import React from 'react';
import { RubriqueTemplateQuery } from '../../graphql-types';
import { RubriqueContent } from '../modules/rubrique/RubriqueContent';
import { SEO } from '../components/2.0version/seo/Seo';

interface IRubriqueTemplate {
  data?: RubriqueTemplateQuery;
}

const RubriqueTemplate = ({ data }: IRubriqueTemplate) => {
  const sanityListingSelection = data?.sanityListingSelection;

  return (
    <>
      <SEO rawMeta={sanityListingSelection?._rawMetadata} />
      <RubriqueContent sanityListingSelection={sanityListingSelection} />
    </>
  );
};

export const QUERY = graphql`
  query RubriqueTemplate($id: String) {
    sanityListingSelection(id: { eq: $id }) {
      _rawMetadata
      id
      _rawTitle
      slug {
        current
      }
      pageHeader {
        _rawTitle
        _rawDescription
      }
      list {
        code
        _id
      }
      equipmentServices {
        label
        filters {
          ... on SanityCriterias {
            id
            criteria
            _rawLabel
            type
          }
          ... on SanityTitleCriteria {
            id
            _rawLabel
            type
            criteria
          }
        }
        id
      }
    }
  }
`;

export default RubriqueTemplate;
